/**
 * The alias to this folder is system/users
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import components from './components'
import routes from './routes'

import UserHistoryMixin from './_mixins/user-history'

export default {
  routes,
  components,
  'mixins': {UserHistoryMixin},
  'vuex': {}
}


